import React from "react";
import { motion } from "framer-motion";
import { Icon } from "./icon";

export const Process = (props) => {
  const steps = props.data || [];

  return (
    <section id="process" className="section overflow-hidden bg-navy-50/50">
      <div
        className="grid-bg mask-fade absolute inset-0 opacity-60"
        aria-hidden="true"
      />

      <div className="container relative z-10">
        <div className="max-w-2xl">
          <span className="eyebrow">How we work</span>
          <h2 className="section-heading mt-6">
            A process built around
            <span className="gradient-text"> visible progress</span>
          </h2>
          <p className="section-sub">
            No black boxes and no six-month silences. Every engagement runs through the
            same four stages, and you see working software throughout.
          </p>
        </div>

        <div className="relative mt-16">
          {/* Connecting rail behind the step cards */}
          <div
            className="absolute left-0 right-0 top-[3.25rem] hidden h-px bg-gradient-to-r from-transparent via-navy-200 to-transparent lg:block"
            aria-hidden="true"
          />

          <ol className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, i) => (
              <motion.li
                key={step.title}
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="group relative"
              >
                <div className="relative z-10 mb-7 flex h-[6.5rem] items-start">
                  <span className="flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-2xl border border-line bg-white text-navy-800 shadow-card transition-all duration-500 ease-smooth group-hover:-translate-y-1 group-hover:border-crimson-200 group-hover:bg-crimson-600 group-hover:text-white group-hover:shadow-brand">
                    <Icon name={step.icon} className="h-7 w-7" />
                  </span>
                  <span className="ml-4 mt-1 font-mono text-sm font-semibold tracking-widest text-ink-faint transition-colors duration-500 group-hover:text-crimson-600">
                    {step.step}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-navy-900">{step.title}</h3>
                <p className="mt-3 leading-relaxed text-ink-muted">{step.text}</p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
